// React Query keys for Staff (under ['shop', id] so shop-wide invalidation reaches them).
export const staffKeys = {
  team: (shopId: string) => ['shop', shopId, 'staff'] as const,
};
